var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"container"},[_c('ul',_vm._l((_vm.model),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.$emit('select', item.value || item)}}},[_vm._v(" "+_vm._s(`${item.title || item}${_vm.sufix}`)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }